module.exports = __webpack_public_path__ + "static/media/weekendPaceChili.a57ef54c.png";